<template>
  <form @submit.prevent="handleSubmit">
    <div class="mb-3">
      <label for="estimateSubcategoryClassification" class="form-label">
        業務区分 <span class="badge text-bg-danger">必須</span>
      </label>
      <select
        id="estimateSubcategoryClassification"
        v-model.number="form.m_business_classification_id"
        class="form-select"
        required
      >
        <option value="" disabled>業務区分を選択してください</option>
        <option
          v-for="classification in businessClassifications"
          :key="classification.id"
          :value="classification.id"
          :disabled="Number(classification.del_flg) === 1"
        >
          {{ classification.business_classification_nm }}
          {{ Number(classification.del_flg) === 1 ? '（削除済み）' : '' }}
        </option>
      </select>
      <div
        v-for="message in errorFor('m_business_classification_id')"
        :key="message"
        class="text-danger mt-1"
      >
        {{ message }}
      </div>
    </div>

    <div class="mb-3">
      <label for="estimateSubcategoryName" class="form-label">
        小分類名（日本語） <span class="badge text-bg-danger">必須</span>
      </label>
      <input
        id="estimateSubcategoryName"
        v-model.trim="form.subcategory_nm"
        type="text"
        class="form-control"
        maxlength="255"
        required
      >
      <div
        v-for="message in errorFor('subcategory_nm')"
        :key="message"
        class="text-danger mt-1"
      >
        {{ message }}
      </div>
    </div>

    <div class="mb-3">
      <label for="estimateSubcategoryNameEn" class="form-label">小分類名（英語）</label>
      <input
        id="estimateSubcategoryNameEn"
        v-model.trim="form.subcategory_nm_en"
        type="text"
        class="form-control"
        maxlength="255"
      >
      <div
        v-for="message in errorFor('subcategory_nm_en')"
        :key="message"
        class="text-danger mt-1"
      >
        {{ message }}
      </div>
    </div>

    <div class="btn-area">
      <button type="button" class="btn btn-secondary mx-1" :disabled="submitting" @click="$emit('cancel')">
        戻る
      </button>
      <button type="submit" class="btn mx-1" :class="submitButtonClass" :disabled="submitting">
        {{ submitting ? '送信中...' : submitLabel }}
      </button>
    </div>
  </form>
</template>

<script setup>
import { reactive, watch } from 'vue';

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({})
  },
  businessClassifications: {
    type: Array,
    default: () => []
  },
  errors: {
    type: Object,
    default: () => ({})
  },
  submitting: {
    type: Boolean,
    default: false
  },
  submitLabel: {
    type: String,
    default: '登録'
  },
  submitButtonClass: {
    type: String,
    default: 'btn-primary'
  }
});

const emit = defineEmits(['submit', 'cancel']);

const form = reactive({
  m_business_classification_id: '',
  subcategory_nm: '',
  subcategory_nm_en: ''
});

watch(
  () => props.initialData,
  (value) => {
    form.m_business_classification_id = value.m_business_classification_id || '';
    form.subcategory_nm = value.subcategory_nm || '';
    form.subcategory_nm_en = value.subcategory_nm_en || '';
  },
  { immediate: true, deep: true }
);

const errorFor = (field) => {
  const messages = props.errors[field] ||
    (field === 'm_business_classification_id' ? props.errors.m_business_classification : []);
  if (!messages) return [];
  return Array.isArray(messages) ? messages : [String(messages)];
};

const handleSubmit = () => {
  emit('submit', {
    m_business_classification_id: Number(form.m_business_classification_id),
    subcategory_nm: form.subcategory_nm,
    subcategory_nm_en: form.subcategory_nm_en
  });
};
</script>
